import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, notification, Row, Spin, Tabs } from 'antd';
import forms from './form';
import { EnrollmentFormContext } from '../../../../../../../providers/EnrollmentFormContextProvider';
import useEnrollmentUpdate from '../../../../../../../hooks/useEnrollmentUpdate';

const { TabPane } = Tabs;

const UAFForm = ({ onFinish }) => {
  const [activeTab, setActiveTab] = useState('1');

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const [updateEnrollment, isLoading] = useEnrollmentUpdate();

  const indexTab = forms.length;

  const handleFinish = () => {
    const formValues = enrollmentForm.getFieldsValue(true);

    if (
      (formValues.effectiveControllers || []).length === 0 &&
      (formValues.finalBeneficiaries || []).length === 0
    ) {
      notification.error({
        description:
          'Por favor ingrese al menos una persona como beneficiario final o control de efectivo.',
        duration: 5,
      });
      return;
    }

    onFinish();
  };

  const saveChanges = (finishOnSave) => {
    const formValues = enrollmentForm.getFieldsValue(true);

    const updatePayload = {
      declaringPerson: { ...formValues.declaringPerson, emailConf: undefined },
      effectiveControllers: formValues.effectiveControllers,
      finalBeneficiaries: formValues.finalBeneficiaries,
      legalRepresentatives: formValues.legalRepresentatives,
      legalStructurePeople: formValues.legalStructurePeople,
    };

    updateEnrollment(updatePayload, finishOnSave && handleFinish);
  };

  const handleNextTab = async (index, tabClick) => {
    try {
      await enrollmentForm.validateFields();
    } catch (e) {
      return;
    }

    const indexNumber = Number(activeTab) + 1;
    if (index === '4' && !tabClick) {
      saveChanges(true);
      return;
    }

    if (indexNumber <= indexTab && !tabClick) {
      setActiveTab(indexNumber.toString());
    } else {
      setActiveTab(index);
    }
  };

  const handleSaveClick = () => {
    saveChanges();
  };

  return (
    <Spin spinning={isLoading}>
      <Tabs activeKey={activeTab} onTabClick={(index) => handleNextTab(index, true)}>
        {forms.map((data) => (
          <TabPane tab={data.title} key={data.key}>
            {data.component}
            <Row gutter={[40]}>
              <Col lg={12} xs={24}>
                <Button type="primary" onClick={() => handleNextTab(data.key, false)}>
                  Continuar
                </Button>
              </Col>
              <Col lg={12} xs={24}>
                <Button type="primary" ghost onClick={handleSaveClick}>
                  Guardar
                </Button>
              </Col>
            </Row>
          </TabPane>
        ))}
      </Tabs>
    </Spin>
  );
};

UAFForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default UAFForm;
